var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioPlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.452 16.584 16.584 12 9.452 7.416v9.168zM12 22.204a9.946 9.946 0 0 1-3.983-.803 10.297 10.297 0 0 1-3.238-2.18 10.298 10.298 0 0 1-2.18-3.237A9.946 9.946 0 0 1 1.798 12c0-1.415.268-2.743.803-3.983a10.297 10.297 0 0 1 2.18-3.238A10.297 10.297 0 0 1 8.016 2.6 9.946 9.946 0 0 1 12 1.798c1.415 0 2.743.268 3.984.803 1.24.535 2.32 1.262 3.237 2.18a10.297 10.297 0 0 1 2.18 3.237A9.946 9.946 0 0 1 22.203 12a9.946 9.946 0 0 1-.802 3.984 10.298 10.298 0 0 1-2.18 3.237 10.298 10.298 0 0 1-3.237 2.18 9.946 9.946 0 0 1-3.984.802zm0-2.276c2.217 0 4.093-.767 5.627-2.3 1.534-1.535 2.301-3.41 2.301-5.628 0-2.217-.767-4.093-2.3-5.627-1.535-1.534-3.41-2.301-5.628-2.301-2.217 0-4.093.767-5.627 2.301C4.839 7.907 4.072 9.783 4.072 12c0 2.217.767 4.093 2.301 5.627 1.534 1.534 3.41 2.301 5.627 2.301z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlay);
export default __webpack_public_path__ + "static/media/audio_play.8cb0a8351501af80162a5f44f814424b.svg";
export { ForwardRef as ReactComponent };